"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "formatFileSize", {
  enumerable: true,
  get: function get() {
    return _humanfilesize.formatFileSize;
  }
});

var _humanfilesize = require("./humanfilesize");
//# sourceMappingURL=index.js.map